/**
 * Where an old /admin/analytics link goes now that it is three pages.
 *
 * The page was split into Overview, Team and Analytics (option 3a), but
 * bookmarks, coaching pills and the Overview footer all point at
 * `/admin/analytics?tab=...`. Rather than rewrite every caller and leave the
 * old URL broken, the old URL keeps working and sends people to the right
 * page, carrying the query it arrived with.
 *
 * Pure, so the mapping is testable without a router.
 */

/** The query keys that mean something on the page being landed on. */
const CARRIED = ['filter', 'memberId', 'autoExpand', 'member'];

/**
 * `?tab=` decides the page:
 * - `employees` is the roster, so /team/members
 * - `pilot` is a report on the programme, so /team/analytics?tab=pilot
 * - anything else, including nothing, is the explaining page
 *
 * The pilot keeps its `tab` because Analytics is the one page with a second
 * view. A manager who follows that link lands on Analytics and sees the
 * trends view, since the pilot report is still owner and admin only.
 */
export function analyticsDestination(search: string): string {
  const params = new URLSearchParams(search || '');
  const tab = (params.get('tab') || '').toLowerCase();
  const path = tab === 'employees' ? '/team/members' : '/team/analytics';

  const carried = new URLSearchParams();
  if (tab === 'pilot') carried.set('tab', 'pilot');
  for (const key of CARRIED) {
    const value = params.get(key);
    if (value) carried.set(key, value);
  }
  const query = carried.toString();
  return query ? `${path}?${query}` : path;
}
